import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Col, Collapse, Row } from "reactstrap";
import withRouter from "../../Components/Common/withRouter";
import SimpleBar from "simplebar-react";

// Import Data
import Navdata from "../LayoutMenuData";
//i18n
import { withTranslation } from "react-i18next";

const HorizontalLayout = (props) => {
  const navData = Navdata().props.children;

  // Split main menu and extra menu items if needed
  let menuItems = [];
  let splitMenuItems = [];
  let menuSplitContainer = 17;

  navData.forEach((value, key) => {
    if (value.isHeader) menuSplitContainer++;
    if (key >= menuSplitContainer) {
      let val = { ...value, childItems: value.subItems || [] };
      splitMenuItems.push(val);
    } else {
      menuItems.push(value);
    }
  });

  const path = props.router.location.pathname;

  // Scroll top + highlight active menu
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const initMenu = () => {
      const pathName = process.env.PUBLIC_URL + path;
      const ul = document.getElementById("navbar-nav");
      if (!ul) return;
      const items = ul.getElementsByTagName("a");
      const itemsArray = [...items];

      removeActivation(itemsArray);

      const matchingMenuItem = itemsArray.find((x) => x.pathname === pathName);
      if (matchingMenuItem) activateParentDropdown(matchingMenuItem);
    };
    initMenu();
  }, [path, props.layoutType]);

  const activateParentDropdown = (item) => {
    if (!item) return;
    item.classList.add("active");

    let parentCollapse = item.closest(".collapse.menu-dropdown");
    if (parentCollapse) {
      parentCollapse.classList.add("show");
      const parentLink = parentCollapse.parentElement.children[0];
      if (parentLink) {
        parentLink.classList.add("active");
        parentLink.setAttribute("aria-expanded", "true");
      }

      // recursive show for nested parents
      let higherCollapse = parentCollapse.parentElement.closest(".collapse.menu-dropdown");
      if (higherCollapse) {
        higherCollapse.classList.add("show");
        const higherLink = higherCollapse.previousElementSibling;
        if (higherLink) higherLink.classList.add("active");
      }
    }
  };

  const removeActivation = (items) => {
    items.forEach((item) => {
      item.classList.remove("active");
      item.setAttribute("aria-expanded", false);
      if (item.nextElementSibling) item.nextElementSibling.classList.remove("show");
    });
  };

  const closeDrawerOnMobile = () => {
    if (window.innerWidth <= 768) {
      document.body.classList.remove("vertical-sidebar-enable");
      document.body.classList.remove("vertical-collpsed");
    }
  };

  // Recursive MenuItem Component
  const MenuItem = ({ item }) => {
    const [isOpen, setIsOpen] = React.useState(item.stateVariables || false);

    const toggleCollapse = (e) => {
      if (item.subItems && item.subItems.length > 0) {
        e.preventDefault();
        setIsOpen(!isOpen);
      }
      closeDrawerOnMobile();
    };

    return (
      <li className="nav-item">
        <Link
          to={item.link || "/#"}
          className="nav-link"
          onClick={toggleCollapse}
          data-bs-toggle={item.subItems && item.subItems.length > 0 ? "collapse" : ""}
        >
          {item.icon && <i className={item.icon}></i>}{" "}
          <span>{props.t(item.label)}</span>
        </Link>

        {item.subItems && item.subItems.length > 0 && (
          <Collapse className="menu-dropdown" isOpen={isOpen}>
            <ul className="nav nav-sm flex-column">
              {item.subItems.map((subItem, key) => (
                <MenuItem key={key} item={subItem} />
              ))}
            </ul>
          </Collapse>
        )}
      </li>
    );
  };

  return (
    <React.Fragment>
      <ul className="navbar-nav" id="navbar-nav">
        {menuItems.map((item, key) =>
          item.isHeader ? (
            <li key={key} className="menu-title">
              <span>{props.t(item.label)}</span>
            </li>
          ) : (
            <MenuItem key={key} item={item} />
          )
        )}
      </ul>
    </React.Fragment>
  );
};

HorizontalLayout.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  router: PropTypes.object,
  layoutType: PropTypes.string,
};

export default withRouter(withTranslation()(HorizontalLayout));